import { OfferCalculator } from "./offer-calculator";

// TODO[offers] - will be refactored in RYNO-7973 (currently copied from common/application)
export class OfferTermCalculator extends OfferCalculator {
    protected getAnnualRate(): number {
        return this.rate / 100;
    }

    protected getMonthlyRate(): number {
        return this.annualRate / 12;
    }

    protected getTotalInterest(term: number): number {
        return this.offerCalculatorService.getTermLoanTotalInterest(this.applicationOffer, term);
    }

    protected getTermPayment(): number {
        return this.offerCalculatorService.getTermLoanPayment(this.amount, this.totalInterest, this.totalNumberOfPayments);
    }

    protected initSampleDraw():void {
        this._sampleDraw = this.amount;
    }

    protected getCommission(): number {
        return this.amount * this.applicationOffer.maxUpsell / 100;
    }

    override get disbursedAmount(): number {
        return this.sampleDraw - this.drawFee - this.originationFeeAmount;
    }
}
